@if ((cut$ | async); as cut) {
  <div class="container">
    <div>
      {{cut.name}}
    </div>
    @if ((currentUser$ | async); as currentUser) {
      <div  class="icons">
        @if (!cut.show) {
          <mat-icon>visibility_off</mat-icon>
        }
        @if (cut.isShared && currentUser.name == cut.author) {
          <mat-icon>person</mat-icon>
        }
        @if (cut.isShared) {
          <mat-icon>share</mat-icon>
        }
      </div>
    }
  </div>
}



